import intl from 'react-intl-universal';

const projectStatusGroupMap: Record<string, string> = {
  Queued: 'INSIGHT.LEGEND.PROJECTS_STATUS_QUEUED',
  'In Progress': 'INSIGHT.LEGEND.PROJECTS_STATUS_IN_PROGRESS',
  Done: 'INSIGHT.LEGEND.PROJECTS_STATUS_DONE',
};

const requestStatusGroupMap: Record<string, string> = {
  'In Review': 'INSIGHT.LEGEND.REQUESTS_STATUS_IN_REVIEW',
  Approved: 'INSIGHT.LEGEND.REQUESTS_STATUS_APPROVED',
  Declined: 'INSIGHT.LEGEND.REQUESTS_STATUS_DECLINED',
  Waitlisted: 'INSIGHT.LEGEND.REQUESTS_STATUS_WAITLISTED',
  'Pending Cancellation': 'INSIGHT.LEGEND.REQUESTS_STATUS_PENDING_CANCELLATION',
  Canceled: 'INSIGHT.LEGEND.REQUESTS_STATUS_CANCELED',
  Completed: 'INSIGHT.LEGEND.REQUESTS_STATUS_COMPLETED',
  'Pending Approval': 'INSIGHT.LEGEND.REQUESTS_STATUS_PENDING_APPROVAL',
  Unknown: 'INSIGHT.LEGEND.REQUESTS_STATUS_UNKNOWN',
};

export function getProjectStatusGroupLegendName(statusGroup: string): string {
  const localizationKey = projectStatusGroupMap[statusGroup];
  return localizationKey ? intl.get(localizationKey) : statusGroup;
}

export function getRequestStatusGroupLegendName(statusGroup: string): string {
  const localizationKey = requestStatusGroupMap[statusGroup];
  return localizationKey ? intl.get(localizationKey) : statusGroup;
}
